import { useQuery } from '@tanstack/react-query'

import { getMoneytreeOauthUrl } from '@src/api'
import { DefaultApiGetMoneytreeOauthUrlRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchMoneytreeOauthUrl = (
  params: DefaultApiGetMoneytreeOauthUrlRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params.organizationId,
    queryFn: () => getMoneytreeOauthUrl(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_MONEYTREE_OAUTH_URL,
      params.organizationId,
      params.nextTo,
    ],
  })
}
